import { fork, put, select } from 'redux-saga/effects'
import { takeEvery } from 'redux-saga'
import { push } from 'react-router-redux'
import { isPlainObject } from 'lodash'

import * as fromBookingSetup from '@src/redux/modules/bookingSetup'
import * as qs from 'utils/querystring'
import * as paths from 'utils/paths'
import { serviceTypes } from '@src/globals'

// /////////////////////////////////////////////////////////////////////////////
// Sagas
// /////////////////////////////////////////////////////////////////////////////
export function * finish (action) {
  const setup = yield select(fromBookingSetup.getSetup)
  const {
    label: neighborhood,
    location: {
      lat: latitude,
      lng: longitude
    }
  } = setup.location

  const convertedSetup = {
    neighborhood,
    coordinates: {
      latitude,
      longitude
    },
    date: setup.date,
    time: ('00' + setup.time).slice(-2) + ':00',
    estimatedHours: setup.estimatedHours,
    skills: convert(setup.skills),
    preferences: convert(setup.preferences),
    serviceTypeId: setup.serviceTypeId
  }

  if (setup.serviceTypeId === serviceTypes.MULTIPLE.id) {
    convertedSetup.weekdays = setup.weekdays
  }

  const querystring = qs.stringify(convertedSetup)
  const url = paths.aliadaSearch(querystring)
  yield put(push(url))
  yield put(fromBookingSetup.reset())
}

// /////////////////////////////////////////////////////////////////////////////
// Watchers
// /////////////////////////////////////////////////////////////////////////////
export function * watchFinish () {
  yield fork(takeEvery, fromBookingSetup.FINISH, finish)
}

// /////////////////////////////////////////////////////////////////////////////
// Root Saga
// /////////////////////////////////////////////////////////////////////////////
export default function * rootSaga () {
  yield * [
    fork(watchFinish)
  ]
}

// /////////////////////////////////////////////////////////////////////////////
// Helper functions
// /////////////////////////////////////////////////////////////////////////////
function convert (obj) {
  if (!isPlainObject(obj)) {
    return obj
  }

  const onlyBooleanValues = checkIfOnlyBooleanValues(obj)
  if (!onlyBooleanValues) {
    return obj
  }

  const result = Object.keys(obj).reduce((acc, key) => {
    if (obj[key]) {
      acc.push(key)
    }

    return acc
  }, [])

  return result
}

function checkIfOnlyBooleanValues (obj) {
  return Object.keys(obj).reduce((acc, key) => {
    const value = obj[key]
    return (typeof value) === 'boolean'
      ? true && acc
      : false
  }, true)
}

export const utils = {
  convert,
  checkIfOnlyBooleanValues
}



// WEBPACK FOOTER //
// ./src/redux/sagas/bookingSetup.js